import axios from "axios";
import { API } from "@/lib/api";

const KEY = "revanche_test_key";
export const DEMO_SESSION = "demo_test_session";

export const isTestMode = () => !!localStorage.getItem(KEY);
export const getTestKey = () => localStorage.getItem(KEY);
export const setTestKey = (k) => localStorage.setItem(KEY, k);
export const clearTestMode = () => localStorage.removeItem(KEY);

export const activateTest = (key) =>
    axios.post(`${API}/test/activate`, { key }).then((r) => r.data);

export const testFulfill = (session_id) =>
    axios.post(`${API}/test/fulfill`, { key: getTestKey(), session_id }).then((r) => r.data);

export const accountInput = (session_id, value) =>
    axios.post(`${API}/session/${session_id}/account`, { value }).then((r) => r.data);
